import { Offcanvas } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import ManageMembersContent from './ManageMembersContent';

interface ManageMemebersDrawerProps {
  show: boolean;
  closeHandler: () => void;
  domain_slug: string | null;
}

const ManageMemebersDrawer = ({
  show,
  closeHandler,
  domain_slug,
}: ManageMemebersDrawerProps) => {
  const [searchParams] = useSearchParams();

  return (
    <Offcanvas
      onShow={() => {
        const offcanvasElement = document.querySelector('.offcanvas');
        if (offcanvasElement) {
          offcanvasElement.removeAttribute('tabindex');
        }
      }}
      show={show}
      onHide={closeHandler}
      style={{ backgroundColor: 'var(--falcon-body-bg)' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="m-0">
              مدیریت دسترسی دامنه &nbsp;
              <strong>{searchParams.get('url')}</strong>
            </div>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="my-0" />
      <Offcanvas.Body className="pb-5 pt-0">
        <ManageMembersContent domain_slug={domain_slug} />
      </Offcanvas.Body>

      <style>
        {`
          .offcanvas{
              width:600px !important;
              max-width:100% !important;
          }
          
          .offcanvas img {
              margin: 0 auto;
              max-width: 100%;
              height: auto;
              display: flex;
          }
       `}
      </style>
    </Offcanvas>
  );
};

export default ManageMemebersDrawer;
